import Chart from "../components/Chart";
import Chart1 from "../components/Chart1";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useTranslation } from "react-i18next";

const XuHuong = () => {
  const { t }: { t: (key: string,  options?: any) => string } = useTranslation();

  return (
    <div className="wrapper">
      <div className="container-web xuhuong bgnew">
        <Header title={t("Xu hướng thị trường")} />

        <main>
          <div className="game-tab-list">
            <ul className="game-tab d-flex align-items-center px-3">
              <li className="active">VND</li>
              <li className="">ETH</li>
              <li className="">USDT</li>
              <li className="">BTC</li>
              <li className="">ADA</li>
              <li className="">AVAX</li>
              <li className="">LTC</li>
            </ul>
          </div>
          <Chart />
          <Chart1 />
          <Footer />
        </main>
      </div>
    </div>
  );
};

export default XuHuong;
